import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MdDialog, MdPaginator, MdSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { IesHttpClient } from '../../Common/ies-http-client.service';
import { Enum } from '../../utility/enum.enum';
import { userRole_globalAdmin, userRole_regionalAdmin } from './../../Common/appConstant';
import { AppMessage } from './../../Common/appMessage';
import { AppUrl } from './../../Common/appUrl';
import { TableDataSource } from './../../Common/md-table';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { DialogConfirmComponentComponent } from './../../Components/dialog-confirm-component/dialog-confirm-component.component';
import { AdmNominateUsersLocationUpdatesService } from './adm-nominate-users-location-updates.service';
import { AppConfig } from './../../Common/appConfiguration';

@Component({
  selector: 'app-adm-nominate-users-location-updates',
  templateUrl: './adm-nominate-users-location-updates.component.html',
  styleUrls: ['./adm-nominate-users-location-updates.component.css'],
  providers: [AdmNominateUsersLocationUpdatesService]
})
export class AdmNominateUsersLocationUpdatesComponent implements OnInit {
  @ViewChild(MdPaginator) paginator: MdPaginator;
  @ViewChild(MdSort) sort: MdSort;

  public searchRegionShow: boolean = true;
  public userRole: string;
  form: FormGroup;
  private userListForm: FormGroup;
  userListItemGroupIndex: any[];
  formControl: any;
  regionFilteredOptions: any;
  locationFilteredOptions: any;
  nameFilteredOptions: any;
  dataSource: TableDataSource | null;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data
  nominateUsersPaginationInfo: any = { totalRecords: 0 }; // Set initial value of Totalrecords property
  displayedColumns = ['firstName', 'lastName', 'email', 'Action'];
  httpClient: IesHttpClient; // used to make object of md-table
  // used in html to pass url/searchParams to update pagination
  appUrl = AppUrl;
  remotePaginationParams;

  constructor(private _sharedService: SharedService, public _utility: Utility, public _appMessage: AppMessage
    , private _admNominateUsersLocationUpdatesService: AdmNominateUsersLocationUpdatesService, public _dialog: MdDialog
    , public _appGlobals: AppGlobals, httpClient: IesHttpClient) {
    this.httpClient = httpClient;
    this.form = new FormGroup(
      {
        searchRegionControl: new FormControl(),
        searchLocationControl: new FormControl()
      }
    );
    this.formControl = this.form.controls;

    this.userListForm = new FormGroup({
      0: new FormGroup({  // "0" is the first initial item of group (serial number and mac address)
        firstName: new FormControl('', Validators.required),
        lastName: new FormControl('', Validators.required),
        email: new FormControl('', [Validators.required, Validators.pattern(AppConfig.emailPattern)])
      })
    });
    this.userListItemGroupIndex = Object.keys(this.userListForm.controls);

    this.userListForm.valueChanges
      .debounceTime(400)
      .subscribe(form => {
        if (!this.userListForm.disabled && this.userListForm.dirty) {
          this._utility.setTxnStatus(true); // display confirm box for FORM changes
        }
      });

  }

  /**
   * RESET Form : remove dyanamically added field when click on Add Nominee
   * perfectScrollSection : this is "ul" element of Form : we need to set scroll to 0 after remove elements to fix scroll
   */
  resetForm(perfectScrollSection : any) {
    let maxLength = this.userListItemGroupIndex.length;
    this.userListForm.reset();
    for (let i: number = 1; i <= maxLength; i++) {
        this.userListForm.removeControl(this.userListItemGroupIndex[i]);
    }
    this.userListItemGroupIndex = Object.keys(this.userListForm.controls);
    this.updateScroll(perfectScrollSection);
  }


  /**
   * Update scroll position to top when form reset and records saved successfully
   * @param perfectScrollSection : scroll element
   */
  updateScroll(perfectScrollSection) {

    if (perfectScrollSection) {
      perfectScrollSection.scrollTo(0, 0);
      setTimeout(() => {
        let scrollChild = perfectScrollSection.lastElementChild;
        scrollChild.style.height = 0;
        scrollChild && scrollChild.firstElementChild ? scrollChild.firstElementChild.style.height = 0 : '';
      }, 30);
    }
  }

  ngOnInit() {
    this._utility.clearTxnStatus();
    this.userRole = this._appGlobals.userInfo.getValue().userRole;

    // Based on Role , show hide region field
    if (this.userRole && this.userRole.toUpperCase() == userRole_globalAdmin || this.userRole.toUpperCase() == userRole_regionalAdmin) {
      this.searchRegionShow = true;
    } else {
      this.searchRegionShow = false;
    }
    // to get data of all regions and bind with AutoComplete
    if (this._sharedService.regionList) {
      this._utility.setDataInComboField('region', null, this.form.controls.searchRegionControl, this);
    } else {
      this._sharedService.getComboFieldsData(Enum.Region, (response) => {
        this._sharedService.regionList = response.response;
        this._utility.setDataInComboField('region', response.response, this.form.controls.searchRegionControl, this);
      });
    }


    // to get data of all regions and bind with AutoComplete
    if (this._sharedService.locationList) {
      this._utility.setDataInComboField('location', null, this.form.controls.searchLocationControl, this);
      // Set value in field if there are single value 
      if (this._sharedService.locationList.length == 1) {
        this.form.controls.searchLocationControl.setValue(this._sharedService.locationList[0]);
        this.bindNomineeList(); // load data for single selected value
      }
    } else {
      this._utility.addLoaderCount();
      this._sharedService.getComboFieldsData(Enum.LocationName, (response) => {
        this._utility.removeLoaderCount();
        this._sharedService.locationList = response.response;
        this._utility.setDataInComboField('location', null, this.form.controls.searchLocationControl, this);
        if (this._sharedService.locationList.length == 1) {
          this.form.controls.searchLocationControl.setValue(this._sharedService.locationList[0]);
          this.bindNomineeList();
        }
      });
    }
    this.dataSource = new TableDataSource(this.dataSubject, this.paginator, this.sort, this.httpClient);
    this.readFormControlValueChanges();
  }

  bindNomineeList() {
    // to get data of Nominee and bind with Grid
    let params = "1?pageSize=100&"; // add pageNumber & pageSize as required in api
    this.remotePaginationParams = "?pageSize=100&";
    let controls = this.form.controls;
    if (controls.searchLocationControl.value && controls.searchLocationControl.value.id) {
      params += "locationId=" + controls.searchLocationControl.value.id;
      this.remotePaginationParams += "locationId=" + controls.searchLocationControl.value.id;
      this._utility.addLoaderCount();
      //this.params = params;
      this._admNominateUsersLocationUpdatesService.getSearchedNominees(params).subscribe(
        response => {
          this._utility.onSuccessCallback(response, null, () => {
            if (response && response.response && response.response.results) {
              //initialize index of grid pagination after every search
              this.paginator.pageIndex = 0;
              this.dataSource.curPage = 2;
              this.dataSubject.next(response.response.results);
              this.nominateUsersPaginationInfo = response.response.paginationInfo; // update paginaton info
            }
          });

        }, error => this._utility.onErrorCallback(error));
    }
  }

  readFormControlValueChanges() {
    this.formControl.searchRegionControl.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.regionChanges(value);
      });

    this.formControl.searchLocationControl.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.locationChanges(value);
      });
  }

  /**
   * Load data in Location dropdown & country droddown
   * TO Load data in location we hit request
   * To Load data in country we simply filter at our end
   * @param value - selected region
   */
  regionChanges(value) {
    if (value && value.id) {
      // Here we have to show locations based on selected region
      let param = "?outputType=" + Enum.LocationName + "&id=" + value.id + "&inputType=" + Enum.Region;
      this._sharedService.requestDataForCombo(param).subscribe(response => {
        this._utility.onSuccessCallback(response, null, () => {
          this._utility.setDataInComboField('location', response.response.results, this.formControl.searchLocationControl, this);
        });
      });
      let data = this._sharedService.locationList.filter(function (item) { if (item.parentId == value.id) return item });
      if (data) {
        this._utility.setDataInComboField('location', data, this.formControl.searchLocationControl, this);
      }
    } else {
      this._utility.setDataInComboField('location', null, this.formControl.searchLocationControl, this); // we have passed second params is null means we are not passing any custom data from here, so it will load all locations
    }
    this.formControl.searchLocationControl.setValue('');
  }

  /**
 * Show Add Nominee section
 * Load data in Grid
 * To Load data in Grid we hit request   
 * @param value - selected location
 */
  locationChanges(value) {
    if (value && value.id) {
      // Here we have to show Add Nominee section
      // Here we have to show data in grid based on selected location
      this.bindNomineeList();
    }
    else {
      this.dataSubject.next([]);
      this.nominateUsersPaginationInfo = { totalRecords: 0 }; // update paginaton info
    }
  }

  removeNominee(recId: number) {
    // to remove the selected nominee
    if (recId && recId > 0) {
      let confirmDialogMsgModel = {
        modelType: "CONFIRMATION",
        msgTitle: this._appMessage.getItem['Common007'],// 'Are you sure',
        msg: this._appMessage.getItem['UMsg00047'],//'Select yes to remove this user.',
        isConfirmBox: true,
        confirmBtnCaption: this._appMessage.getItem['Common014'],//'Yes',
        cancelBtnCaption: this._appMessage.getItem['Common015'],//'No'
      };
      let confirmDialogMsgRef = this._dialog.open(DialogConfirmComponentComponent,
        {
          data: confirmDialogMsgModel
        });
      confirmDialogMsgRef.afterClosed().subscribe(result => {
        if (result == "1") {
          let params = "?id=" + recId; // add id of selected nominee      
          this._utility.addLoaderCount();
          this._admNominateUsersLocationUpdatesService.removeNominee(params).subscribe(
            response => {
              this._utility.onSuccessCallback(response, this._appMessage.getItem['UMsg00048']
                , () => {
                  this.bindNomineeList();
                });

            }, error => this._utility.onErrorCallback(error));
        }
      });
    }
  }

  /**
   * When click on Add , a new row will be added in form with field First Name , last Name & Email.
   * @param index - position
   * @param perfectScrollSection  - this is scroll div element
   */
  onAdd(index: number, perfectScrollSection: any): void {
    index = Number(index);
    let objControl = new FormControl('', Validators.required);
    let maxIndex = Math.max.apply(this, this.userListItemGroupIndex); // find max index which are already exist in form group 
    let newIndex = maxIndex + 1; // increase index (it will be newly added row Index)
    // create object for new group item
    let newItem = new FormGroup({
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.pattern(AppConfig.emailPattern)])
    })
    this.userListForm.addControl(newIndex, newItem);
    this.userListItemGroupIndex = Object.keys(this.userListForm.controls);

    // update scroll position to bottom when add new element
    setTimeout(() => {
      perfectScrollSection.scrollTo(0, perfectScrollSection.scrollHeight);
    }, 40);
  }

  /**
   * When click on delete button selected row should removed
   * If there are more then 1 item then only remove
   * @param rowIndex - row index on which we have clicked
   * @param perfectScrollSection  - this is  perfect scrollbar element
   */
  onDelete(rowIndex: any, perfectScrollSection: any): void {
    rowIndex = Number(rowIndex);
    if (this.userListItemGroupIndex.length > 1) {
      this.userListForm.removeControl(rowIndex);
      this.userListItemGroupIndex = Object.keys(this.userListForm.controls);
      // update scroll position to bottom when add new element
      setTimeout(() => {
        perfectScrollSection.scrollTo(0, 0);
      }, 20);
    }
  }

  // When user click on 'ADD NOMINEE' Button
  addNominees(perfectScrollSection: any) {
    let controls = this.form.controls;
    if (controls.searchLocationControl.value && controls.searchLocationControl.value.id) {
      let form = this.userListForm;
      if (form.invalid) {
        return;
      }
      let values = this._utility.objValues(form.getRawValue());
      let param = {
        locationId: controls.searchLocationControl.value.id,
        nominees: values
      };

      this._utility.addLoaderCount();
      this._admNominateUsersLocationUpdatesService.addNominee(param)
        .subscribe(
        response => {
          let message = this._appMessage.getItem['UMsg00050'];
          this._utility.onSuccessCallback(response, message, () => {
            this._utility.clearTxnStatus();
            this.bindNomineeList();
            this.resetForm(perfectScrollSection);
          });
        }, error => this._utility.onErrorCallback(error));
    }
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-nominate-users-location-updates/adm-nominate-users-location-updates.component.ts